export const ChaptersData: any[] = [
    {
        'type': 'series',
        'episode': '6',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'B',
        'id': 32462,
        'date': '06/12/24',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300_v2C.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '5',
        'part': 'B',
        'id': 32434,
        'date': '06/05/24',
        'title': 'Re:Anima',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/ReAnime_vol02_HP_chapterWheel_3000x3000.jpg',
                'color': 'yellow',
            },
        ],
        'readableUrl': 're-anima',
    },
    {
        'type': 'series',
        'episode': '12',
        'part': 'B',
        'id': 32430,
        'date': '06/05/24',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/BLOODBLADE_vol03_HP_chapterWheel_3000x3000.jpg',
                'color': 'red',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '6',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'A',
        'id': 32461,
        'date': '05/29/24',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300_v2C.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '5',
        'part': 'A',
        'id': 32433,
        'date': '05/22/24',
        'title': 'Re:Anima',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/ReAnime_vol02_HP_chapterWheel_3000x3000.jpg',
                'color': 'yellow',
            },
        ],
        'readableUrl': 're-anima',
    },
    {
        'type': 'series',
        'episode': '12',
        'part': 'A',
        'id': 32429,
        'date': '05/22/24',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/BLOODBLADE_vol03_HP_chapterWheel_3000x3000.jpg',
                'color': 'red',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '5',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'C',
        'id': 32330,
        'date': '05/15/24',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300_v2C.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '4',
        'part': 'B',
        'id': 32394,
        'date': '05/08/24',
        'title': 'Re:Anima',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/ReAnime_vol02_HP_chapterWheel_3000x3000.jpg',
                'color': 'yellow',
            },
        ],
        'readableUrl': 're-anima',
    },
    {
        'type': 'series',
        'episode': '11',
        'part': 'B',
        'id': 32393,
        'date': '05/08/24',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/BLOODBLADE_vol03_HP_chapterWheel_3000x3000.jpg',
                'color': 'red',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '5',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'B',
        'id': 32329,
        'date': '05/01/24',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300_v2C.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '4',
        'part': 'A',
        'id': 32365,
        'date': '04/24/24',
        'title': 'Re:Anima',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/ReAnime_vol02_HP_chapterWheel_3000x3000.jpg',
                'color': 'yellow',
            },
        ],
        'readableUrl': 're-anima',
    },
    {
        'type': 'series',
        'episode': '11',
        'part': 'A',
        'id': 32392,
        'date': '04/24/24',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/BLOODBLADE_vol03_HP_chapterWheel_3000x3000.jpg',
                'color': 'red',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '5',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'A',
        'id': 32328,
        'date': '04/17/24',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300_v2C.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '3',
        'part': 'B',
        'id': 32267,
        'date': '04/10/24',
        'title': 'Re:Anima',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/ReAnima_HP_chapterWheel_3000x300.png',
                'color': 'none',
            },
        ],
        'readableUrl': 're-anima',
    },
    {
        'type': 'series',
        'episode': '10',
        'part': 'B',
        'id': 32291,
        'date': '04/10/24',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/855b6ec30f3d757653c0.png',
                'color': 'none',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '4',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'C',
        'id': 32289,
        'date': '04/03/24',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300_v2C.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '3',
        'part': 'A',
        'id': 32266,
        'date': '03/27/24',
        'title': 'Re:Anima',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/ReAnima_HP_chapterWheel_3000x300.png',
                'color': 'none',
            },
        ],
        'readableUrl': 're-anima',
    },
    {
        'type': 'series',
        'episode': '10',
        'part': 'A',
        'id': 32290,
        'date': '03/27/24',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/855b6ec30f3d757653c0.png',
                'color': 'none',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '4',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'B',
        'id': 32288,
        'date': '03/20/24',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300_v2C.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '2',
        'part': 'B',
        'id': 32181,
        'date': '03/13/24',
        'title': 'Re:Anima',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/ReAnima_HP_chapterWheel_3000x300.png',
                'color': 'none',
            },
        ],
        'readableUrl': 're-anima',
    },
    {
        'type': 'series',
        'episode': '9',
        'part': 'B',
        'id': 32183,
        'date': '03/13/24',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/855b6ec30f3d757653c0.png',
                'color': 'none',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '4',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'A',
        'id': 32287,
        'date': '03/06/24',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300_v2C.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '2',
        'part': 'A',
        'id': 32180,
        'date': '02/28/24',
        'title': 'Re:Anima',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/ReAnima_HP_chapterWheel_3000x300.png',
                'color': 'none',
            },
        ],
        'readableUrl': 're-anima',
    },
    {
        'type': 'series',
        'episode': '9',
        'part': 'A',
        'id': 32182,
        'date': '02/28/24',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/855b6ec30f3d757653c0.png',
                'color': 'none',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '3',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'C',
        'id': 32138,
        'date': '02/21/24',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '1',
        'part': 'B',
        'id': 32179,
        'date': '02/14/24',
        'title': 'Re:Anima',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/ReAnima_HP_chapterWheel_3000x300.png',
                'color': 'none',
            },
        ],
        'readableUrl': 're-anima',
    },
    {
        'type': 'series',
        'episode': '8',
        'part': 'B',
        'id': 32140,
        'date': '02/14/24',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/855b6ec30f3d757653c0.png',
                'color': 'none',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '3',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'B',
        'id': 32137,
        'date': '02/07/24',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '1',
        'part': 'A',
        'id': 32178,
        'date': '01/31/24',
        'title': 'Re:Anima',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/ReAnima_HP_chapterWheel_3000x300.png',
                'color': 'none',
            },
        ],
        'readableUrl': 're-anima',
    },
    {
        'type': 'series',
        'episode': '8',
        'part': 'A',
        'id': 32139,
        'date': '01/31/24',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/855b6ec30f3d757653c0.png',
                'color': 'none',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '3',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'A',
        'id': 32136,
        'date': '01/24/24',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '7',
        'part': 'B',
        'id': 32081,
        'date': '01/17/24',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/BLOODBLADE_VOL02_CH_3000x3000_A.jpg',
                'color': 'red',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '2',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'C',
        'id': 32066,
        'date': '01/10/24',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '7',
        'part': 'A',
        'id': 32080,
        'date': '01/03/24',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/BLOODBLADE_VOL02_CH_3000x3000_A.jpg',
                'color': 'red',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '2',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'B',
        'id': 32065,
        'date': '12/27/23',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '6',
        'part': 'B',
        'id': 32067,
        'date': '12/20/23',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/BLOODBLADE_VOL02_CH_3000x3000_A.jpg',
                'color': 'red',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '2',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'A',
        'id': 32064,
        'date': '12/13/23',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '6',
        'part': 'A',
        'id': 32051,
        'date': '12/06/23',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/BLOODBLADE_VOL02_CH_3000x3000_A.jpg',
                'color': 'red',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '1',
        'alternative': 'Spell', // Alternative for episode word
        'part': 'B',
        'id': 31986,
        'date': '11/29/23',
        'title': 'The Spellbook Library',
        'text': 'Read Chapter',
        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/SpellbookLibrary_HP_chapterWheel_3000x300.jpg',
                'color': 'none',
            },
        ],
        'readableUrl': 'the-spellbook-library',
    },
    {
        'type': 'series',
        'episode': '3',
        'id': 31895,
        'date': '10/18/23',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',

        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/855b6ec30f3d757653c0.png',
                'color': 'none',
            },
        ],
        'readableUrl': 'blood-blade',
    },
    {
        'type': 'series',
        'episode': '2',
        'id': 31875,
        'date': '10/04/23',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',

        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/855b6ec30f3d757653c0.png',
                'color': 'none',
            },
        ],
        'readableUrl': 'blood-blade',
    },

    {
        'type': 'series',
        'episode': '1',
        'id': 31851,
        'date': '9/20/23',
        'title': 'BLOOD BLADE',
        'text': 'Read Chapter',

        'thumbnails': [
            {
                'width': 1200,
                'height': 960,
                'url': 'https://cdn.kodansha.us/statics/855b6ec30f3d757653c0.png',
                'color': 'none',
            },
        ],
        'readableUrl': 'blood-blade',
    },
];
